/** React Query cache key for in-app notifications (scoped by customer — matches API `customer_id`). */
export function notificationsQueryKey(customerId: number | null | undefined) {
  return ['notifications', customerId ?? null] as const;
}
